// extracted by mini-css-extract-plugin
module.exports = {"deadline":"deadline__3WHdJ","time":"time__2STfU","date":"date__3LV36","calendar":"calendar__M42CN","clear":"clear__hsa8a","bottom":"bottom__3KpJ3","top":"top__3zDO1"};